/* [Component: storesImport] */
import { CapabilitiesStore } from '../components/Capabilities/stores/CapabilitiesStore';
import { DefinitionsStore } from '../components/Definitions/stores/DefinitionsStore';
import { DropdownStore } from '../components/Dropdown/stores/DropdownStore';
import { HeadingStore } from '../components/Heading/stores/HeadingStore';
import { SearchStore } from '../components/Search/stores/SearchStore';
import { SearchResultItemStore } from '../components/SearchResultItem/stores/SearchResultItemStore';
import { TStoreContext } from '../models/app/TStoreContext';
// import { ExampleStore } from '../components/Exmaple/stores/ExampleStore';

export function setupStoreContext(storeContext: TStoreContext) {
	//storeContext.set('exampleStore', new ExampleStore(storeContext, storeContext.manifest));
	/* [Component: stores] */
	storeContext.set('searchResultItemStore', new SearchResultItemStore(storeContext, storeContext.manifest));
	storeContext.set('searchStore', new SearchStore(storeContext, storeContext.manifest));
	storeContext.set('headingStore', new HeadingStore(storeContext, storeContext.manifest));
	storeContext.set('dropdownStore', new DropdownStore(storeContext, storeContext.manifest));
	storeContext.set('definitionsStore', new DefinitionsStore(storeContext, storeContext.manifest));
	storeContext.set('capabilitiesStore', new CapabilitiesStore(storeContext, storeContext.manifest));
}
